export default {
  'auth.welcome': 'Bon retour',
  'auth.subtitle': 'Connectez-vous à votre compte NexChat. Vos messages sont privés et sécurisés.',
  'auth.continue': 'Continuer avec NexChat',
  'app.name': 'NexChat',
  'app.loading': 'Chargement…',
  'app.online': 'En ligne',
  'app.away': 'Absent',
  'app.busy': 'Occupé',
  'app.appear_offline': 'Apparaître hors ligne',
  'sidebar.conversations': 'Vos conversations',
  'sidebar.new_conversation': 'Nouvelle conversation',
  'sidebar.search': 'Rechercher des conversations…',
  'sidebar.loading': 'Chargement des salles…',
  'sidebar.empty': 'Aucune conversation.\nCréez-en une pour commencer.',
  'sidebar.select': 'Sélectionnez une conversation ou démarrez-en une nouvelle.',
  'chat.encrypted': 'Cette conversation est chiffrée de bout en bout',
  'chat.loading': 'Chargement des messages…',
  'chat.no_messages': 'Aucun message',
  'chat.be_first': 'Soyez le premier à dire quelque chose !',
  'chat.voice_call': 'Appel vocal',
  'chat.video_call': 'Appel vidéo',
  'chat.pins': 'Messages épinglés',
  'chat.starred': 'Messages favoris',
  'chat.search': 'Rechercher des messages',
  'input.placeholder': 'Message {room}…',
  'input.hint_send': 'Appuyez sur {enter} pour envoyer · {shift_enter} pour nouvelle ligne',
  'input.poll': 'Créer un sondage',
  'input.gif': 'GIF et Stickers',
  'input.attach': 'Joindre un fichier',
  'input.schedule': 'Programmer un message',
  'input.record': 'Maintenez ou cliquez pour enregistrer',
  'input.nexai': 'Demander à NexAI',
  'msg.reply': 'Répondre',
  'msg.edit': 'Modifier',
  'msg.delete': 'Supprimer',
  'msg.copy': 'Copier',
  'msg.forward': 'Transférer',
  'msg.pin': 'Épingler',
  'msg.unpin': 'Désépingler',
  'msg.star': 'Mettre en favori',
  'msg.unstar': 'Retirer des favoris',
  'msg.thread': 'Fil',
  'msg.translate': 'Traduire',
  'msg.react': 'Réagir',
  'msg.edited': 'modifié',
  'msg.deleted': 'Ce message a été supprimé',
  'thread.title': 'Fil de discussion',
  'thread.replies': 'Réponses',
  'thread.reply_placeholder': 'Répondre dans le fil…',
  'thread.hint': 'Entrée pour répondre · Maj+Entrée pour nouvelle ligne',
  'thread.summarise': '✨ Résumé',
  'thread.summarising': '⏳ Résumé en cours…',
  'thread.summary_title': '✨ Résumé IA',
  'thread.not_enough': 'Pas assez de messages à résumer',
  'nexai.placeholder': 'Demander à NexAI…',
  'nexai.title': 'NexAI',
  'nexai.thinking': 'Réflexion…',
  'nexai.clear': 'Effacer',
  'search.title': 'Rechercher des messages',
  'search.placeholder': 'Rechercher des messages, personnes, mots-clés…',
  'search.empty': 'Tapez pour rechercher',
  'search.no_results': 'Aucun résultat',
  'search.searching': 'Recherche…',
  'search.results': '{count} résultat{plural}',
  'profile.edit': 'Modifier le profil',
  'profile.theme': 'Thème',
  'profile.scheduled': 'Messages programmés',
  'profile.notifications': 'Notifications',
  'profile.logout': 'Se déconnecter',
  'theme.title': '🎨 Choisir un thème',
  'theme.subtitle': '12 thèmes — variantes claires et sombres.',
  'theme.close': 'Fermer',
  'notif.title': 'Paramètres de notification',
  'notif.browser': 'Notifications du navigateur',
  'notif.browser_sub': 'Afficher les alertes pour les nouveaux messages',
  'notif.sound': 'Notifications sonores',
  'notif.sound_sub': 'Jouer un son pour les nouveaux messages',
  'notif.volume': 'Volume',
  'notif.push': 'Notifications push',
  'notif.push_sub': 'Recevoir des alertes même quand NexChat est fermé',
  'notif.push_enabled': '✓ Activé',
  'notif.push_enable': 'Activer push',
  'notif.push_enabling': 'Activation…',
  'notif.sounds_title': 'Sons personnalisés',
  'notif.preview': '▶ Aperçu',
  'notif.upload': '📎 Télécharger',
  'notif.clear': '✕ Effacer',
  'notif.new_message': 'Nouveau message',
  'notif.mention': '@ Mention',
  'notif.dm': 'Message direct',
  'notif.ringtone': 'Sonnerie (appels)',
  'notif.save': 'Enregistrer',
  'notif.close': 'Fermer',
  'room.new_title': 'Nouvelle conversation',
  'room.dm_tab': '💬 Message direct',
  'room.channel_tab': '# Canal',
  'room.dm_placeholder': '@utilisateur:nexchat.ethosserver.com',
  'room.channel_placeholder': 'ex. général',
  'room.channel_label': 'Nom du canal',
  'room.dm_label': 'Nom d\'utilisateur',
  'room.start_dm': 'Démarrer la conversation',
  'room.create_channel': 'Créer le canal',
  'room.cancel': 'Annuler',
  'poll.create': 'Créer un sondage',
  'poll.question': 'Question',
  'poll.question_placeholder': 'Posez une question…',
  'poll.option': 'Option {n}',
  'poll.add_option': '+ Ajouter une option',
  'poll.single': 'Choix unique',
  'poll.multi': 'Choix multiple',
  'poll.anonymous': 'Anonyme',
  'poll.submit': 'Créer le sondage',
  'poll.cancel': 'Annuler',
  'poll.end': 'Terminer le sondage',
  'poll.ended': 'Sondage terminé',
  'poll.votes': '{n} vote{plural}',
  'btn.save': 'Enregistrer',
  'btn.cancel': 'Annuler',
  'btn.close': 'Fermer',
  'btn.send': 'Envoyer',
  'btn.delete': 'Supprimer',
  'btn.edit': 'Modifier',
  'btn.confirm': 'Confirmer',
  'toast.copied': 'Copié dans le presse-papiers',
  'toast.message_deleted': 'Message supprimé',
  'toast.profile_updated': 'Profil mis à jour',
  'toast.offline_queued': 'Hors ligne — message en file d\'attente',
  'toast.back_online': 'De retour en ligne — {count} message{plural} envoyé{plural}',
  'toast.scheduled': 'Programmé pour {time}',
  'toast.poll_created': 'Sondage créé !',
};
